import React, { use, useEffect, useState } from 'react'
import { toastSweetAlert } from '../../Helpers/ToastSweetAlert'
import Box from '../../Global/Box'

const FormAttachments = ({
  refWizard,
  data,
  setData,
  setIsValidSteps,
  maxFiles = 5,
}) => {
  const [isDragging, setIsDragging] = useState(false)
  const [files, setFiles] = useState([])

  useEffect(() => {
    if (data.stepAttachments.length > 0) {
      setFiles(data.stepAttachments)
    }
  }, [data])

  const handleDrop = (e) => {
    e.preventDefault()
    if (files.length >= maxFiles)
      return toastSweetAlert({
        mode: 'error',
        message: `Solo puedes subir hasta ${maxFiles} ${
          files.length > 1 ? 'archivos' : 'archivo'
        }`,
      })

    const file = e.dataTransfer.files[0]

    const firstType = file.type.split('/')[0]
    const getType = file.type.split('/')[1]

    const allowedTypes = ['png', 'jpeg', 'jpg', 'pdf']

    if (!allowedTypes.includes(getType)) {
      return toastSweetAlert({
        mode: 'error',
        message: 'Este tipo de archivo no esta permitido',
      })
    }

    const allowedSize = 1024 * 1024 * 5

    if (file.size > allowedSize) {
      return toastSweetAlert({
        mode: 'error',
        message: 'El archivo es muy grande',
      })
    }

    const newFiles = [...e.dataTransfer.files]
    setFiles((prevFiles) => [
      ...prevFiles,
      ...newFiles.slice(0, maxFiles - prevFiles.length),
    ])
    handleDragLeave()
  }
  const handleDragOver = (e) => {
    e.preventDefault()

    const dropzone = document.querySelector('.dropzone')
    if (dropzone) {
      dropzone.addEventListener('dragover', (e) => {
        e.preventDefault()
        dropzone.classList.add('dragging')
        setIsDragging(true)
      })
    }
  }

  const handleDragLeave = (e) => {
    // e.preventDefault()
    const dropzone = document.querySelector('.dropzone')
    if (dropzone) {
      dropzone.classList.remove('dragging')
      setIsDragging(false)
    }
  }

  const handleRemoveFile = (index) => {
    const newFiles = files.filter((file, i) => i !== index)
    setFiles(newFiles)
  }

  const removeSkeleton = (index) => {
    const skeleton = document.getElementById(`skeleton-image-${index}`)
    if (skeleton) {
      skeleton.style.display = 'none'
    }
  }

  const handleNext = (e) => {
    e.preventDefault()
    // if (files.length === 0) {
    //   return toastSweetAlert({
    //     mode: 'warning',
    //     message: 'Debes subir al menos un archivo',
    //   })
    // }
    setData((prev) => ({
      ...prev,
      stepAttachments: files,
    }))

    setIsValidSteps((prev) => ({
      ...prev,
      stepAttachments: true,
    }))

    // refWizard.current.next
  }

  return (
    <Box
      withCard={false}
      btnSubmit={(e) => handleNext(e)}
      content={
        <>
          <div className="col-12 container-drag-drop">
            <div
              className="dropzone size-all-col"
              onDrop={handleDrop}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
            >
              {files.length > 0 ? (
                <div className="dropzone-image-container">
                  {files.map((file, index) => (
                    <div
                      key={index}
                      className="dropzone-container-image  dropzone-container-image-many"
                      style={{
                        textAlign: 'center',
                        position: 'relative',
                        gap: '5px',
                        borderRadius: '5px',
                      }}
                    >
                      <button
                        onClick={() => handleRemoveFile(index)}
                        className="dropzone--delete-button"
                      >
                        ×
                      </button>
                      {file.type.split('/')[0] === 'image' ? (
                        <img
                          src={URL.createObjectURL(file)}
                          alt={file.name}
                          title={file.name}
                          className="dropzone-image dropzone-image-many"
                          onLoad={() => removeSkeleton(index)}
                        />
                      ) : (
                        //preview pdf file
                        <iframe
                          title={file.name}
                          style={{
                            marginTop: '10px',
                          }}
                          src={URL.createObjectURL(file)}
                          type="application/pdf"
                          className="dropzone-image dropzone-image-many"
                          onLoad={() => removeSkeleton(index)}
                        />
                      )}
                      <p className="dropzone-filename-many">{file.name}</p>
                      <div
                        id={`skeleton-image-${index}`}
                        className="skeleton-image"
                      ></div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="dropzone-content">
                  {isDragging ? (
                    <div className="dropzone-dragging">
                      <i className="fas fa-cloud-upload-alt dropzone-icon"></i>
                      <p className="dropzone-text">Suelta el archivo</p>
                    </div>
                  ) : (
                    <div className="dropzone-message">
                      <p className="dropzone-text">
                        Arrastra y suelta los archivos aquí
                      </p>
                    </div>
                  )}
                </div>
              )}
              <div className="dropzone-info">
                <p>
                  Formatos permitidos: .png, .jpeg, .jpg, .pdf - Tamaño máximo:
                  5MB
                </p>
                <p>
                  {files.length}/{maxFiles}
                  {maxFiles > 1 ? ' archivos' : ' archivo'}
                </p>
              </div>
            </div>
          </div>
        </>
      }
    />
  )
}

export default FormAttachments
